import * as yup from "yup"
import validationMessages from "@utils/validation/messages";

const emailRequired = () =>
    yup.string()
        .required(validationMessages.required)
        .email(validationMessages.emailInvalid)

export default emailRequired